import './SearchBox.scss'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from 'antd'

const { Search } = Input

export default ({ currentQuery, onChange, onSearch, loading = false }) => {
  const { t } = useTranslation()
  const searchInProgress = useRef(false)
  const enterKeyDown = useRef(false)

  const handleKeyDown = event => {
    if (event.key !== 'Enter' && event.keyCode !== 13) return
    if (enterKeyDown.current) {
      event.preventDefault()
      event.stopPropagation()
      return
    }
    enterKeyDown.current = true
  }

  const handleKeyUp = event => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      enterKeyDown.current = false
    }
  }

  const handleSearch = async (...args) => {
    const event = args[1] || args[0]
    if (event && (event.key === 'Enter' || event.keyCode === 13) && enterKeyDown.current) return
    if (loading || searchInProgress.current) return

    searchInProgress.current = true
    try {
      return await onSearch(...args)
    } finally {
      searchInProgress.current = false
    }
  }

  return (
    <div id="searchbox">
      <Search placeholder={ t('messages.aml.enterNameOrRut') } onChange={ onChange } onKeyDown={ handleKeyDown } onKeyUp={ handleKeyUp } onBlur={ () => { enterKeyDown.current = false } } onSearch={ handleSearch } value={ currentQuery } loading={ loading || searchInProgress.current } allowClear enterButton />
    </div>
  )
}
